import { useMediaQuery } from "react-responsive";
import { MOBILE_BREAKPOINT_PX } from "@/utils/breakpoints";

// components
import Logo from "@/components/Header/Logo";
import Nav from "@/components/Header/Nav";
import HeroEl from "./HeroEl";

// styles
import "./Hero.css";
import "@/components/Header/Header.css";

// --------------------------------------------------------------------------------------

export default function Hero() {
	const isMobile = useMediaQuery({
		query: `(max-width: ${MOBILE_BREAKPOINT_PX}px)`,
	});

	return (
		<section className="sponsor-hero">
			<header className="global-header">
				<Logo />
				{/* On bigger screens, show Nav at the top */}
				{!isMobile && <Nav />}
			</header>

			<HeroEl />

			{/* On mobile, show Nav at the bottom */}
			{isMobile && <Nav />}
		</section>
	);
}
